import { Directive, Output, HostListener, EventEmitter } from '@angular/core';

@Directive({
  selector: '[input-Foucs]'
})
export class FoucsDirective {

  @Output() onInputFocus: EventEmitter<boolean> = new EventEmitter<false>();

  @HostListener("focus", ["$event"])
  public onListenerTriggered(event: any): void {
    this.onInputFocus.emit(true);
  }
  @HostListener("focusout", ["$event"])
  public onListenerTriggeredOut(event: any): void {
    this.onInputFocus.emit(false);
    }
}
